import { createApp, App as IAapp } from 'vue';
import webSee from '@websee/core';
import recordscreen from '@websee/recordscreen';
// import performance from '@websee/performance';
// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n';
import App from './App.vue';
import router from './router';
import plugins from './plugins';
import store from './store/index';
import 'virtual:uno.css';
import 'virtual:svg-icons-register';
// 引入message组件样式
import 'element-plus/theme-chalk/src/message.scss';
import 'element-plus/theme-chalk/src/message-box.scss';
import { setupGlobCom } from './components';
import './responsive.ts';
import { isUseMonitor } from './utils/log.ts';

const useMonitor = (app: IAapp<Element>) => {
    app.use(webSee, {
        dsn: 'https://120.92.90.34/reportData',
        apikey: 'brain', // 项目唯一的id
        repeatCodeError: true, // 开启错误上报去重，重复的代码错误只上报一次,只有重复的代码报错会上报，其它报错不会去重
        silentWhiteScreen: false, // 开启白屏检测
        skeletonProject: false, // 项目是否有骨架屏
        // throttleDelayTime:2,
        overTime: 5,
        handleHttpStatus(data: any) {
            // 自定义hook, 根据接口返回的 response 判断请求是否正确
            if (data.Status >= 200 && data.Status < 300) {
                return true;
            } else {
                return false;
            }
        },
        beforeDataReport(data: any) {
            const { getUserName, getUserId, getUserUUid, getIp } = useStore('user');
            return {
                ...data,
                version: `${__VERSION__}`,
                username: getUserName.value,
                userId: getUserId.value,
                ip: getIp.value,
                userUUid: getUserUUid.value,
            };
        },
    });
    // webSee.use(performance, null);
    webSee.use(recordscreen, { recordScreentime: 10 });
};

const setup = async () => {
    const app = createApp(App);
    // if (isUseMonitor()) {
    //     useMonitor(app);
    // }
    app.use(router);
    app.use(store);
    setupGlobCom(app);
    await setupI18n(app);
    app.use(plugins);
    app.mount('#app');
};
setup();
